import React from 'react';
import numeral from 'numeral';
import CirculatingIcon from '../../icons/CirculatingIcon';
import TotalSupplyIcon from '../../icons/TotalSupplyIcon';
import './CirculatingSupply.css';

const isSomething = val => !(val === undefined || val === null);
const withRequest = (WrappedComponent) => {
  return class extends React.Component {
    constructor(props) {
      super(props)
      this.state = {
        request: null,
        error: null,
        circulatingSupply: null,
        totalSupply: null
      };
    }
    componentDidMount() {
      this.setState({ request: fetch('https://bczpm3z1ra.execute-api.eu-west-1.amazonaws.com/api') });
    }
    render() {
      return (
        <WrappedComponent
          {...this.state} 
          setValue={props => this.setState({
            request: null,
            error: null,
            totalSupply: props.total_supply,
            circulatingSupply: props.circulating_supply
          })}
          setError={error => this.setState({ error })}
        />
      )
    }
  }
};

const CardValue = ({ error, amount }) => (
  <div className="card-bottom">
    {!error && amount
      ? numeral(amount).format('0,0').toUpperCase()
      : '0.00'}
  </div>
);

const CirculatingSupply = ({ totalSupply, request, circulatingSupply, error, setValue, setError }) => {
  if (!totalSupply && !circulatingSupply && !error && request) {
    request
      .then(res => res.ok
        ? res
        : Promise.reject('Error loading data'))
      .then(res => res.json())
      .then(setValue)
      .catch(setError);
  }

  return (
    <div className="content-wrapper">
      <div className="cards">
        <div className="circulating-card">
          {error && <div className="loading-error">There was an error loading your data</div>}
          <div className="card-content">
            <div className="card-top">
              <CirculatingIcon />
              <div>Circulating Supply</div>
            </div>
            <CardValue error={error} amount={circulatingSupply} />
          </div>
        </div>
        {isSomething(totalSupply) && (
          <div className="circulating-card">
            {error && <div className="loading-error">There was an error loading your data</div>}
            <div className="card-content">
              <div className="card-top">
                <TotalSupplyIcon />
                <div>Total Supply</div>
              </div>
              <CardValue error={error} amount={totalSupply} />
            </div>
          </div>
        )}
        </div>
      <div className="pattern" />
    </div>
  );
};

export default withRequest(CirculatingSupply);



// WEBPACK FOOTER //
// ./src/components/CirculatingSupply/CirculatingSupply.js